import React from "react";

// import Typography from "@material-ui/core/Typography";

import NodeIcon from "./node-icon";

interface Props {
  showId: boolean;
  value: any;
}

function FormattedNodeRow(props: Props) {
  const {
    id,
    name /*, __typename, error, warn, hasForecast, executing, enabled*/,
  } = props.value;
  const { showId } = props;
  return (
    <span style={{ cursor: "pointer" }}>
      <NodeIcon {...props.value} />
      &nbsp;
      {name}
      {showId && <span>&nbsp;({id})</span>}
    </span>
  );
}

export default FormattedNodeRow;
